module.exports = __webpack_public_path__ + "img/ticket-002.bd77cb45.svg";